import { render, staticRenderFns } from "./Sussess.vue?vue&type=template&id=2b0aae9a&scoped=true&"
import script from "./Sussess.vue?vue&type=script&lang=js&"
export * from "./Sussess.vue?vue&type=script&lang=js&"
import style0 from "./Sussess.vue?vue&type=style&index=0&id=2b0aae9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0aae9a",
  null
  
)

export default component.exports